import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';
import {metadataService} from "../../_services"

export class LoanSubmittedConfirmation extends Component {
    static displayName = LoanSubmittedConfirmation.name;

    render() {
        return (
            <div className="SignUpConfirmation">
                <Row>
                    <Col sm={12} md={{ size: 8, offset: 2 }} >
                        <h3 className="text-center">{metadataService.getTitle('YourApplicationHasBeenSubmitted')}</h3>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={{ size: 8, offset: 2 }} >
                        <h6 className="text-center">{"It looks like you are already a registered user of my.sunloan.com. Please Sign In or contact support at 1-800-SUN-LOAN (1-800-786-5626) if you have forgotten your username."}</h6>
                    </Col>
                </Row>
            </div>
        );
    }
}

